<template>
  <div class="container">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      :count='count'
      :current="page"
    >
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem" v-if="roleType!==2">
            <label>门店名称:</label>
            <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
          </div>
          <div class="queryItem">
            <goodsSearchItem v-model="query.nameMix"></goodsSearchItem>
            <!-- <label>商品:</label>
            <lk-input clearable v-model='query.nameMix' class="item" placeholder="商品名称、通用名称、助记码、商品编码"></lk-input> -->
          </div>
          <div class="queryItem">
            <label>商品类型:</label>
            <lk-select v-model='query.goodsType' class="item" clearable>
              <lk-option v-for="(item, index) in getNormalGoodsTypes" :key="index" :value="item.value">{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>来源:</label>
            <lk-select v-model='query.purchaseType' class="item" clearable>
              <lk-option v-for="(item, index) in getGoodsOrigin" :key="index" :value="item.value">{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>规格:</label>
            <lk-input clearable v-model='query.spec' class="item" placeholder="请输入"></lk-input>
          </div>
          <!-- <div class="queryItem">
            <label>单位:</label>
            <lk-input clearable v-model='query.goodsSerialCode' class="item" placeholder="请输入"></lk-input>
          </div>
          <div class="queryItem">
            <label>产地:</label>
            <lk-input clearable v-model='query.goodsSerialCode' class="item" placeholder="请输入"></lk-input>
          </div>  -->
          <div class="queryItem">
            <label>生产企业:</label>
            <lk-input clearable v-model='query.producer' class="item" placeholder="请输入"></lk-input>
          </div>
          <div class="queryItem">
            <label>批准文号/注册证号:</label>
            <lk-input clearable v-model='query.approvalCode' class="item" placeholder="请输入"></lk-input>
          </div>
          <div class="queryItem">
            <label>单号:</label>
            <lk-input clearable v-model='query.inspectionCode' class="item" placeholder="请输入"></lk-input>
          </div>
          <div class="queryItem">
            <label>创建时间:</label>
            <timeStampDatePicker  v-model='query.createTimeStart' class="item"></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label>至</label>
            <timeStampDatePicker  v-model='query.createTimeEnd' class="item"></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label>是否DTP:</label>
            <lk-select v-model='query.isDtp' class="item">
              <lk-option v-for="(item, index) in isDtpList" :key="index" :value="index + 1">{{item}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>储存条件:</label>
            <lk-select v-model='query.storageCondition' class="item">
              <lk-option v-for="(item, index) in storageConditionsList" :key="index" :value="item.dictionaryIndex">{{item.dictionaryName}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>GSP分类:</label>
            <lk-select v-model='query.gspIdList' class="item" filterable multiple>
              <lk-option v-for="(item, index) in gspList" :key="index" :value="item.id">{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>进项税率:</label>
            <lk-select v-model='query.inputTaxRateList' class="item" multiple>
              <lk-option v-for="(item, index) in taxRate" :key="index" :value="item">{{item}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>随货同行单:</label>
            <lk-input clearable v-model="query.travelNo" class="item" placeholder="请输入"></lk-input>
          </div>
          <div class="queryItem">
            <label>供应商:</label>
            <SupplierListSelect v-model.trim="query.supplierStoreIdList" :multiple="true" class="item" placeholder="请输入"></SupplierListSelect>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <!-- 异步导出Excel Start -->
        <DownloadButton class="mb16" @on-click="handleExport" v-if="handlePermission('inspectionStatsDownloadBtn')"></DownloadButton>
        <!-- 异步导出Excel End -->
        <div class="Report-total-container">
          <div class="Report-total-title">合计</div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">验收数量:</div>
            <div class="Report-total-item-value">{{total.allNumDisplay}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">总含税金额:</div>
            <div class="Report-total-item-value">{{total.allAmountDisplay}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">总不含税金额(确认):</div>
            <div class="Report-total-item-value">{{total.allAmountWithoutTaxDisplay}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">总税额:</div>
            <div class="Report-total-item-value">{{total.allTaxDisplay}}</div>
          </div>
        </div>
        <lk-table border :columns='columns' :data='tableData'></lk-table>
      </div>
    </QueryFrame>

  </div>
</template>
<script>

import { mapGetters } from 'vuex';
import QueryFrame from '../../components/frame/QueryFrame.vue';
import purchase from '../../services/purchase';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import goodsService from '../../services/goods';
import DownloadButton from '../../components/download/DownloadButton';
import SupplierListSelect from '../../components/SupplierListSelect.vue';

export default {
  name: 'inspectionStats',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    DownloadButton,
    SupplierListSelect,
  },
  data() {
    return {
      isDtpList: ['是', '否'],
      storageConditionsList: [],
      taxRate: [0, 3, 6, 9, 13],
      gspList: [],
      query: {
        storeIdList: [],
        spec: '',
        producer: '',
        approvalCode: '',
        createTimeStart: null,
        createTimeEnd: null,
        inspectionCode: '',
        nameMix: '',
        goodsType: '',
        inputTaxRateList: [],
        purchaseType: 1,
        travelNo: null,
      },
      columns: [
        {
          title: '门店名称',
          tooltip: true,
          key: 'purchaseInspectionStoreName',
          minWidth: 142,
        },
        {
          title: '业务日期',
          tooltip: true,
          key: 'purchaseInspectionCreateTime',
          minWidth: 144,
        },
        {
          title: '验收单号',
          tooltip: true,
          key: 'purchaseInspectionCode',
          minWidth: 172,
        },
        {
          title: '收货单号',
          tooltip: true,
          key: 'purchaseReceiptCode',
          minWidth: 172,
        },
        {
          title: '采购单号',
          tooltip: true,
          key: 'purchaseOrderCode',
          minWidth: 172,
        },
        {
          title: '计划单号',
          tooltip: true,
          key: 'purchasePlanCode',
          minWidth: 172,
        },
        {
          title: '商品类型',
          tooltip: true,
          key: 'purchaseMedicineGoodsTypeName',
          minWidth: 82,
        },
        {
          title: '来源',
          key: 'purchaseMedicinePurchaseTypeName',
          tooltip: true,
          minWidth: 82,
        },
        {
          title: '状态',
          tooltip: true,
          key: 'purchaseInspectionStatusName',
          minWidth: 80,
        },
        {
          title: '商品编码',
          tooltip: true,
          key: 'purchaseMedicineDrugSerialCode',
          minWidth: 82,
        },
        {
          title: '通用名称',
          tooltip: true,
          key: 'medicineInfoVoApprovedDrugNames',
          minWidth: 142,
        },
        {
          title: '商品名称',
          tooltip: true,
          key: 'medicineInfoVoGoodsName',
          minWidth: 142,
        },
        {
          title: '规格',
          tooltip: true,
          key: 'medicineInfoVoSpecifications',
          minWidth: 130,
        },
        {
          title: '批准文号/注册证号',
          key: 'medicineInfoVoApprovalCode',
          tooltip: true,
          minWidth: 134,
        },
        {
          title: '储存条件',
          tooltip: true,
          key: 'medicineInfoVoStorageConditions',
          minWidth: 112,
        },
        {
          title: '是否DTP',
          key: 'purchaseMedicineIsDtpName',
          tooltip: true,
          minWidth: 82,
        },
        {
          title: 'GSP分类',
          tooltip: true,
          key: 'medicineInfoVoGspLabelNames',
          minWidth: 142,
        },
        {
          title: '生产厂家',
          tooltip: true,
          key: 'medicineInfoVoManufacturer',
          minWidth: 142,
        },
        {
          title: '验收数量',
          tooltip: true,
          key: 'purchaseInspectionInfoPassNum',
          minWidth: 116,
        },
        {
          title: '包装单位',
          tooltip: true,
          key: 'medicineInfoVoDrugMinimumPackagingUnitString',
          minWidth: 82,
        },
        {
          title: '实际单价',
          tooltip: true,
          key: 'purchaseInspectionInfoPriceBeforeTax',
          minWidth: 86,
        },
        {
          title: '税率(%)',
          tooltip: true,
          key: 'purchaseInspectionInfoTaxRate',
          minWidth: 80,
        },
        {
          title: '总含税金额',
          tooltip: true,
          key: 'purchaseInspectionInfoTotalPriceBeforeTax',
          minWidth: 94,
        },
        {
          title: '不含税单价',
          tooltip: true,
          key: 'purchaseInspectionInfoPriceAfterTax',
          minWidth: 94,
        },
        {
          title: '总不含税金额',
          tooltip: true,
          key: 'purchaseInspectionInfoTotalPriceAfterTaxDisplay',
          minWidth: 106,
        },
        {
          title: '税额',
          tooltip: true,
          key: 'purchaseInspectionInfoTotalTaxDisplay',
          minWidth: 94,
        },
        {
          title: '批次',
          tooltip: true,
          key: 'purchaseInspectionInfoGoodsBatchSeq',
          minWidth: 130,
        },
        {
          title: '批号',
          tooltip: true,
          key: 'purchaseInspectionInfoGoodsBatchNum',
          minWidth: 80,
        },
        {
          title: '生产日期',
          tooltip: true,
          key: 'purchaseInspectionInfoProdDate',
          minWidth: 106,
        },
        {
          title: '有效日期',
          tooltip: true,
          key: 'purchaseInspectionInfoExpiryDate',
          minWidth: 106,
        },
        {
          title: '起始温度',
          tooltip: true,
          key: 'purchaseReceiptInfoStartTemperature',
          minWidth: 82,
        },
        {
          title: '终止温度',
          tooltip: true,
          key: 'purchaseReceiptInfoEndTemperature',
          minWidth: 82,
        },
        {
          title: '仓库',
          tooltip: true,
          key: 'purchaseInspectionInfoWareHouseName',
          minWidth: 92,
        },
        {
          title: '货位',
          tooltip: true,
          key: 'purchaseInspectionInfoLocationCode',
          minWidth: 92,
        },
        {
          title: '供应商名称',
          tooltip: true,
          key: 'purchaseMedicineSupplierName',
          minWidth: 142,
        },
        {
          title: '成本类型',
          tooltip: true,
          key: 'purchaseMedicinePaymentName',
          minWidth: 82,
        },
        {
          title: '验收员',
          key: 'purchaseInspectionCreateUserName',
          minWidth: 116,
        },
        {
          title: '复核员',
          key: 'purchaseInspectionReviewerName',
          minWidth: 116,
        },
        {
          title: '随货同行单', key: 'purchaseReceiptTravelNo', minWidth: 116, tooltip: true,
        },
      ],
      tableData: [],
      total: {},
    };
  },
  computed: {
    // getNormalGoodsTypes() {
    //   return this.$store.state.publicParams.goodsTypes;
    // },
    ...mapGetters(['getNormalGoodsTypes', 'getGoodsOrigin']),
  },
  methods: {
    getTotal() {
      const params = Object.assign({}, this.query);
      // if (params.createTimeStart) {
      //   params.createTimeStart = (new Date(params.createTimeStart)).getTime();
      // }
      // if (params.createTimeEnd) {
      //   params.createTimeEnd = (new Date(params.createTimeEnd)).getTime();
      // }
      purchase.getInspectionStatsSummary(params).then((res) => {
        if (res.data.status === 200) {
          this.total = res.data.data;
        }
      });
    },
    clear() {
      this.query = {
        storeIdList: [],
        inputTaxRateList: [],
      };
    },
    handleExport() {
      const params = Object.assign({}, this.query);
      // if (params.createTimeStart) {
      //   params.createTimeStart = (new Date(params.createTimeStart)).getTime();
      // }
      // if (params.createTimeEnd) {
      //   params.createTimeEnd = (new Date(params.createTimeEnd)).getTime();
      // }
      params.page = 0;
      params.size = 0;
      params.queryCondition = utils.getQueryCondition('.queryContainer');
      purchase.inspectionStatsDownload(params)
        .then((res) => {
          // utils.downLoadExcel(res, '验收明细');
          if (res.data.status !== 200) {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    getStorageConditionsList() {
      goodsService.GoodsDictionary({ dictionaryTypeEnum: 9 }).then((res) => {
        if (res.data.status === 200) {
          this.storageConditionsList = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getGSPList() {
      goodsService.listGoodsLabels({ categoryId: 1 }).then((res) => {
        if (res.data.status === 200) {
          this.gspList = res.data.data.list;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getData() {
      const params = Object.assign({}, this.query);
      params.page = this.page;
      params.size = this.size;
      // if (params.createTimeStart) {
      //   params.createTimeStart = (new Date(params.createTimeStart)).getTime();
      // }
      // if (params.createTimeEnd) {
      //   params.createTimeEnd = (new Date(params.createTimeEnd)).getTime();
      // }
      this.getTotal();
      purchase.inspectionStats(params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            result.purchaseInspectionInfoProdDate = result.purchaseInspectionInfoProdDate && utils.formatTime(result.purchaseInspectionInfoProdDate, 'YYYY/MM/DD');
            result.purchaseInspectionInfoExpiryDate = result.purchaseInspectionInfoExpiryDate && utils.formatTime(result.purchaseInspectionInfoExpiryDate, 'YYYY/MM/DD');
            // console.log(result);
            result.purchaseInspectionCreateTime = utils.formatDate(result.purchaseInspectionCreateTime);
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  created() {
    this.getStorageConditionsList();
    this.getGSPList();
    this.handleSearch(true);
  },
};
</script>
